import React from 'react'

import environment from 'environment'

import { store } from 'app-redux/store'
import { useCanEditDeck } from 'app-redux/deck/selectors'
import { handleMultiSelect } from 'app-redux/active/actions/multiSelectors'

import { CardType, defaultColorLabel } from 'types/deck'
import { GlobalColorTag } from 'services/apiTypes/colorTag.types'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import SimpleSpinner from 'components/elements/SimpleSpinner'

import useDeckColorTagOptions from 'hooks/useDeckColorTagOptions'
import { getContrastingColor } from 'utils/calculateContrast'

import styles from './cornerQuantity.module.scss'

type Props = {
  card: CardType
  onCardUpdate: (updatedCard: CardType) => void
  loader?: boolean
}

const CornerQuantity = ({ card, onCardUpdate, loader = false }: Props) => {
  const canEditDeck = useCanEditDeck()

  const handleUpdateCard = (selectedTag: GlobalColorTag) => onCardUpdate({ ...card, colorLabel: selectedTag })

  const [options, onFocus] = useDeckColorTagOptions(handleUpdateCard)

  const calculatedTextColor = getContrastingColor(card.colorLabel.color)

  const handleCtrlClick = (e: React.MouseEvent) => {
    const controlKey = environment.getOnMac() ? e.metaKey : e.ctrlKey

    if (!controlKey) return

    e.preventDefault()

    const { cardMap } = store.getState().deck

    const matchingColorTagCards = Object.values(cardMap).filter(
      c => JSON.stringify(c.colorLabel) === JSON.stringify(card.colorLabel),
    )

    handleMultiSelect(matchingColorTagCards)
  }

  return (
    <ArchidektDropdown
      triggerClassName={styles.container}
      menuClassName={styles.menu}
      disabled={!canEditDeck}
      onFocus={onFocus}
      options={options}>
      <button
        // Note the use of onMouseDown here prevents onClick from firing (and thus prevent focusing and opening the dropdown) when e.preventDefault is called
        onMouseDown={handleCtrlClick}
        onFocus={() => console.log('button focues')}
        disabled={!canEditDeck}
        className={styles.cornerQuantity}
        style={{ color: calculatedTextColor, backgroundColor: card.colorLabel.color || defaultColorLabel.color }}>
        {!loader && card.qty}
        {loader && <SimpleSpinner size="xSmall" />}
      </button>
    </ArchidektDropdown>
  )
}

export default CornerQuantity
